import { makeStyles } from '@mui/styles';

export const useLockerUtilisationHeaderStyles = makeStyles(() => ({
  root: {
    marginBottom: '8px'
  },
  timePeriod: {
    color: '#979797'
  }
}));
